import React from "react";
import {
  WSControlGroup,
  WSElement,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  Account,
  OAuthAuthorizationCandidate
} from "@wingspanhq/wingspan-api-sdk";
import { candidateAccountName } from "../hooks/useQueryCandidateAccounts";

interface CandidateSelectorProps {
  candidates: OAuthAuthorizationCandidate[];
  accountsById: Map<string, Account>;
  /** Index into `candidates`, or undefined while nothing is chosen yet. */
  selectedIndex?: number;
  onChange: (index: number) => void;
}

/**
 * Account + Role picker for the multi-candidate case.
 *
 * A candidate is an (Account, roleScope) pair, so the same Account can appear
 * more than once at different tiers. The option value is therefore the index
 * into `candidates`, not the accountId — keying on accountId would silently
 * collapse two tiers of the same Account into one option.
 */
export const CandidateSelector: React.FC<CandidateSelectorProps> = ({
  candidates,
  accountsById,
  selectedIndex,
  onChange
}) => (
  <WSElement mb="L">
    <WSText.Paragraph mb="S" weight="medium">
      Choose the account and access level to grant:
    </WSText.Paragraph>
    <WSControlGroup
      name="oauthCandidate"
      type="radio"
      value={selectedIndex === undefined ? "" : String(selectedIndex)}
      onChange={value => onChange(Number(value))}
      options={candidates.map((candidate, index) => ({
        value: String(index),
        label: candidateAccountName(candidate.accountId, accountsById),
        description: candidate.roleScope
      }))}
    />
  </WSElement>
);
